import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconSearchSvg } from "./IconSearchSvg.mjs";
const IconSearch = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconSearchSvg, ...svgProps }) });
export {
  IconSearch
};
